import './pdfViewer';

(function() {
  var nTimer = setInterval(function() {
    if (window.jQuery) {
      clearInterval(nTimer);
      (function($) {
          $(document).ready(function() {
              var path = $('#pdf-container').data('path'),
                  filenameForDw = $('#pdf-container').data('name'),
                  wrapper   = document.getElementById("handbook-wrapper");

              var pageWidthScale = wrapper.clientWidth;
              if($(window).width() < 767)
                var pageHeightScale = (wrapper.clientWidth*16)/9;
              else 
                var pageHeightScale = (wrapper.clientWidth*4)/3;

              $(wrapper).css('height',pageHeightScale+'px');

               $('#pdf-container').pdfViewer({
                  url: path,
                  scale: 1, // initial scale as 100%
                  downloadFilename: filenameForDw // File name for download
              });

              var viewer = $('#pdf-container').data('pdfViewer');

              $('#prev-page').on('click', function() {
                  viewer.prevPage();
              });
              $('#next-page').on('click', function() {
                  viewer.nextPage();
              });
              $('#zoom-in').on('click', function() {
                  viewer.zoomIn();
              });
              $('#zoom-out').on('click', function() {
                  viewer.zoomOut();
              });
              $('#automatic-zoom').on('change', function() {
                  var zoomType = $(this).val();
                  if (isNaN(zoomType)) {
                      viewer.setZoom(zoomType); // Use string-type zoom
                  } else {
                      viewer.setNumericZoom(zoomType); // Use numeric zoom
                  }
              });
              $('#page-number').on('change', function() {
                  var pageNumber = parseInt($(this).val());
                  viewer.scrollToPage(pageNumber);
              });
              $('#download-pdf').on('click', function() {
                  viewer.downloadPDF();
              });



        });
      })(jQuery);
    }
  }, 200);
})();
